/**
 * Generated bundle index. Do not edit.
 */

export {MdPaginatorModule,PageEvent,MdPaginator,MdPaginatorIntl,MatPaginator,MatPaginatorIntl,MatPaginatorModule} from './public_api';
